import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  HostListener,
  OnDestroy
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import {
  ActivatedRoute,
  NavigationExtras,
  Router,
} from '@angular/router';
// import { ActivatedRoute, Router } from '@angular/router';
import { CategorySelectionComponent } from 'src/app/components/products-mgmt/category-selection/category-selection.component';
import {ProductBrandsPage} from '../../../pages/product-brands/product-brands.page'
import { ImageGalleryPage } from '../../../pages/image-gallery/image-gallery.page'
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ModalController,
  NavController,
  ToastController,
  LoadingController,
  AnimationController,
  IonContent
} from '@ionic/angular';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { DataService } from 'src/app/services/data.service';
import { AddImagePage } from 'src/app/pages/add-image/add-image.page';
import { ProductSettingsPage } from 'src/app/pages/product-settings/product-settings.page';
import { AttributesAddComponent } from '../../products-mgmt/attributes-add/attributes-add.component';
import { AttributesEditComponent } from '../../products-mgmt/attributes-edit/attributes-edit.component';
import { AttributesAddImgComponent } from '../../products-mgmt/attributes-add-img/attributes-add-img.component';
import {SpecificationAttributesPage} from 'src/app/pages/specification-attributes/specification-attributes.page';
import { ReturnPolicyPage } from '../../../pages/return-policy/return-policy.page';
import { ReplacementPolicyPage } from '../../../pages/replacement-policy/replacement-policy.page';
import { UONE } from 'long';
// import { AddImagePage } from '../add-image/add-image.page';
// import { Storage } from '@ionic/storage';
import { ViewportScroller, Location} from "@angular/common";

@Component({
  selector: 'app-view-product',
  templateUrl: './view-product.component.html',
  styleUrls: ['./view-product.component.scss'],
})
export class ViewProductComponent implements OnInit,OnDestroy {
  product_form ;
  page_no = 0
  issue_list:any=[]
  policy_list:any = []
  replacement_list:any = []
  page_size = 10
  item:any={};
  Product_attributes:any = [];
  tax_templates:any = [];
  attibute_list:any = [];
  submitted=false;
  image;
  cat:any=[];
  // @Input() title;
  @Input() title:any = 'Add';
  @Input() product_id;

  @Input() is_not_shown;
  @Input() input_box_width;
  @Input() header_none;
  // @Input() product_detail;
  // menulist:any=[];
  categorylist;
  brands_list;
  activeitem: any;
  categoryimagedata: any = [];
  categoryfile: any = [];
  upload_images: any = [];
  closeResult;
  category_name;
  category:any={};
  product:any={};
  itemaddon: any = {}; 
  close_att;
  i;
  products;
  search_bar = false;
  search_bar_brands = false
  search_txt = '';
  search_txt_brands = '';
  search_array:any = [];
  brands_search_array:any = [];
  segment_value = 'basic';
  scanActive = true;
  scanResult:any = null;
  check_box = false;
  store;
  specifications : any = {
    specifications_group : [],
    specifications_attributes : [],
  }

  specification:any=[];
  // specification_data:any={};
  uom_list = [];
  current_value = 'images';

  @ViewChild('video',{static:false}) video:any = ElementRef;
  // @ViewChild(IonContent) content:any = IonContent;
  // @ViewChild('gallery') gallery: IonContent
  @ViewChild('category_content') category_content:any = ElementRef;
  @ViewChild(IonContent) content!: IonContent;
  // @ViewChild('gallery') gallery:any = ElementRef;
  
  // @Output() goto_center = new EventEmitter();
  videoElement:any;
  route_id;
  get_selected_brands:any = [];
  drop_down2 = false;

  constructor(public location:Location,private scroller: ViewportScroller,private route:ActivatedRoute,public toastController: ToastController,private animationCtrl: AnimationController,private activeRoute: ActivatedRoute,private router: Router,private navCtrl: NavController,public modalCtrl: ModalController,public DBservice: DataService,public formBuilder:FormBuilder,private chf:ChangeDetectorRef,public loadingCtrl: LoadingController) {
   // this.get_all_category();
   
   }

   ionViewDidEnter(){
     // console.log("kalaiselvam")
     
   }

   del_options(data,index){
     this.product.variant_combination.splice(index,1)
   }

   async bulk_edit_combination(){
     this.check_uom();
     let temp = this.product.images
    const modal = await this.modalCtrl.create({
      component : AttributesEditComponent,
      // cssClass : 'category-selection-popup',
      cssClass : 'left-side-variants',
      componentProps : {
        product_info : this.product,
      },
      enterAnimation: this.enterAnimation ,
      leaveAnimation: this.leaveAnimation,
    })

    await modal.present();
   }

   check_uom(){
     if(this.product.variant_combination && this.product.variant_combination.length > 0){
        let check = this.product.variant_combination.filter(obj => obj.uom == null)
        if(this.title == 'Add' && check && check.length > 0){
          check.map(res =>{
            res.uom = this.product_form.value.uom
          })
        }
      }
   }
   async edit_combination(data,index){
     this.check_uom();
     let temp = this.product.images
    const modal = await this.modalCtrl.create({
      component : AttributesEditComponent,
      // cssClass : 'category-selection-popup',
      cssClass : 'left-side-variants',
      componentProps : {
        product_info : this.product,
        edit_info: data,
        edit_index:index + 1
      },
      enterAnimation: this.enterAnimation ,
      leaveAnimation: this.leaveAnimation,
    })

    await modal.present();
   }

   get_uom(){
    this.DBservice.get_uom_list().subscribe(res=>{
      if(res && res.data){
         this.uom_list =  res.data;
      }
    })
   }

   unsubscribe;

   ngOnDestroy(): void {
    this.unsubscribe ? this.unsubscribe.unsubscribe() : null
   }


   ngOnInit() {

   
    // this.product = undefined;
    this.DBservice.product_detail.subscribe(res=>{
      // console.log(res);
      this.product = res ?  res:{};
      this.load_product_Values()
    })

    this.unsubscribe = this.DBservice.update_product.subscribe(res=>{
      console.log(res);
      if(res){
        this.product = res;
      }
    })

   
      // this.route.params.subscribe(res =>{
      //   // console.log(res);

      //   if(res && res.category_id){
      //     this.title = 'Edit'
      //     this.attibute_list = [];
      //     this.route_id = res.category_id;
      //       this.get_product_detail(res.category_id);
      //   }else{
      //     if(this.product){
      //       this.product = this.product;
      //       (this.product.product_attributes && this.product.product_attributes.length != 0) ? null : this.product.product_attributes = [];
      //       (this.product.product_images && this.product.product_images.length != 0) ? null : this.product.product_images = [];
      //       (this.product.product_categories && this.product.product_categories.length != 0) ? null : this.product.product_categories = [];
      //       (this.product.product_brands && this.product.product_brands.length != 0) ? null : this.product.product_brands = [];
      //     }else{
      //       (this.product.product_attributes && this.product.product_attributes.length != 0) ? null : this.product.product_attributes = [];
      //       (this.product.product_images && this.product.product_images.length != 0) ? null : this.product.product_images = [];
      //       (this.product.product_categories && this.product.product_categories.length != 0) ? null : this.product.product_categories = [];
      //       (this.product.product_brands && this.product.product_brands.length != 0) ? null : this.product.product_brands = [];
      //     }
          
      //     // console.log(this.product)
      //   }
      // })
     this.get_uom();
     this.get_brands_list();
     this.get_addons();
     this.get_categorylist();
     this.get_speficication();
     this.get_speficication_attr();
     
     if(this.product_id){
      this.title = 'Edit'
      this.attibute_list = [];
      this.route_id = this.product_id.product_id;
      // console.log(this.product_id)
      // console.log(params)
      this.get_product_detail(this.route_id);
     }
     
      this.activeRoute.queryParams.subscribe((params:any) => {
      if (params && params.id) {
        this.title = 'Edit'
        this.attibute_list = [];
        this.route_id = params.id;
        // console.log(params)
        this.get_product_detail(params.id);
      }
      else{
          if(this.product){
            this.product = this.product;
            (this.product.product_attributes && this.product.product_attributes.length != 0) ? null : this.product.product_attributes = [];
            (this.product.product_images && this.product.product_images.length != 0) ? null : this.product.product_images = [];
            (this.product.product_categories && this.product.product_categories.length != 0) ? null : this.product.product_categories = [];
            (this.product.product_brands && this.product.product_brands.length != 0) ? null : this.product.product_brands = [];
          }else{
            (this.product.product_attributes && this.product.product_attributes.length != 0) ? null : this.product.product_attributes = [];
            (this.product.product_images && this.product.product_images.length != 0) ? null : this.product.product_images = [];
            (this.product.product_categories && this.product.product_categories.length != 0) ? null : this.product.product_categories = [];
            (this.product.product_brands && this.product.product_brands.length != 0) ? null : this.product.product_brands = [];
          }
          
          console.log(this.product)
        }
    });

    // console.log(this.product)

    let v = {}
    this.form_data.map(res =>{
      res.group_fileds.map(op =>{
        v[op.name] = new FormControl( op.value ,[])
      })
    })

    this.product_form =  this.formBuilder.group(v);
    console.log(this.product_form);
  }


  ionViewWillEnter(){
    // this.content.scrollToTop();
    this.route.params.subscribe((res:any) =>{
      // console.log(res);
      if(res && res.category_id){
        this.title = 'Edit'
        this.attibute_list = [];
          this.get_product_detail(res.category_id);
      }
    })
  }

   goto_page(page)
   {
     this.get_categorylist();
      this.router.navigateByUrl('/'+page);
      this.reset_form();
   }

   reset_form(){
    this.product_form.reset();
    this.product.product_categories = [];
   }

   get_product_detail(id){
    // var data = {  Product_id: id  }
    var data = id;
    this.DBservice.get_product_details(data).subscribe(data => {
       this.product = data.message;
       // console.log(this.product)
      //  console.log(data.message.product_brands)
      //  this.get_selected_brands = data.message.product_brands;
       this.product.product_brands = data.message.product_brands;
       this.specification = data.message.product_specification_attributes;
       
      //  this.product.full_description = this.DBservice.rich_text;
      //  this.product_variants = this.product.product_attributes;
      this.DBservice.variant_shown = (this.product.has_variants && this.product.has_variants == 1) ? true : false;
       if(this.product.variant_combination && this.product.variant_combination.length != 0){
        this.product.variant_combination.map(res=>{
          // res.varient_json = JSON.parse(res.varient_json);
          res.varient_json = res.attribute_html;
          res.image_list = JSON.parse(res.image_list);
          if(res.image_list){
            let image = res.image_list.find(img=>img.is_primary == 1);
            res.image ? res.image = image.image : '';
          }
          
        })
       }else if(this.product.variant_combination && this.product.variant_combination.length == 0){
        this.product_with_combo()
       }

       if(this.product.product_attributes && this.product.product_attributes.length != 0){
        this.product.product_attributes.map(res=>{
          if(res.options){
            let is_pre_selected = res.options.find(v=>v.is_pre_selected == 1);
            if(is_pre_selected){
              res.option_value = is_pre_selected.option_value;
            }
          }
         
        })
       }
       this.load_product_Values();
     }, error => {  console.log(JSON.stringify(error.json()));  });
  }


  product_with_combo(){
    if((this.product.attribute_options && this.product.attribute_options.length != 0) && (this.product.product_attributes && this.product.product_attributes.length != 0) ){
      this.product.product_attributes.map(res=>{

        res.options = [];

        let array_options = this.product.attribute_options.filter(r=> r.attribute == res.product_attribute);

        if(array_options.length != 0){
          // console.log(array_options);
          array_options.map(option=>{
            let datas = [{attribute_id :(option && option.name) ? (option.name + '\n') : '', 'option_value':option.option_value,'attribute':res.attribute,'price':0,'quantity':0}]
            res.options = [...res.options,...datas];

            if(res.all_options){
              res.all_options = res.options.length == res.all_options.length ? [] : res.all_options;
            }else{
              res.all_options = [];
            }
            
            if(this.product.variant_combination && this.product.variant_combination.length != 0){
               let check = this.product.variant_combination.find(variant=> { return variant.attribute_id && variant.attribute_id.includes(option.attribute_id)});
               if(check){
                res.is_active = true;
               }
            }

          })
        }
      })
    }

    this.product.with_out_combo = this.product.product_attributes.filter(res=> { return !res.is_active });
    
  }

  goto_center(value){
    this.current_value = value.name;
    var itemList = document.getElementById(this.current_value) as HTMLInputElement;
    let check = document.getElementById(this.current_value) as HTMLInputElement;
    check.scrollIntoView({ behavior: "smooth", block: "start",  inline: "start" });
    // check.scrollTop += 1000;
    // this.content.scrollX(0, this.target.nativeElement.offsetTop, 500);
    // this.content.scrollToPoint(0, check.offsetTop, 500); 
  }

   get_addons(){
      this.DBservice.get_all_attributes().subscribe(data => {
          this.Product_attributes = data.message
      }, error => {  });

      // this.DBservice.get_tax_templates()
      // .subscribe(data => {
      //   this.tax_templates= data.message
      //   }, error => {
      //   console.log(JSON.stringify(error.json()));
      // });
   
  }  


  async add_attributes(){
    // if(this.title == 'Add'){
    //   let obj = {alert:true,item:'Please save the product before adding variant.',bg_color:this.DBservice.alert_bg}
    //   this.DBservice.alert_animate.next(obj);
    // }else{
      this.add_attributes1();
    // }
  }


  async add_attributes1(){

    this.product = this.product == undefined ? this.DBservice.product_info.product : this.product;
    localStorage['store'] = JSON.stringify(this.product);
    // console.log(this.product)
    let temp = this.product.images
    const modal = await this.modalCtrl.create({
      component : AttributesAddComponent,
      // cssClass : 'add-attribute-modal',
      cssClass:'left-side-variants',
      componentProps : {
        // product_variants:this.product_variants,
        // product:this.product,
        product1:this.product,
        title :this.title,
        all_attributes:this.Product_attributes,
        // post_product:this.variant_event($event),
        // attributes:this.attributes
      },
      enterAnimation: this.enterAnimation ,
      leaveAnimation: this.leaveAnimation,
    })

    await modal.present();
    await modal.onWillDismiss().then(res =>{
        if(res.data && res.data.status == 'success'){
          this.product = res.data.item;
          console.log(this.product);
        }else{
          // this.product = JSON.parse(localStorage['store']);
          // console.log(this.product)
        }
    })
  }

    // ion-model slide left transaction
    enterAnimation = (baseEl: HTMLElement) => { 
      var root:any = baseEl.shadowRoot;
      const backdropAnimation = this.animationCtrl
        .create()
        .addElement(root.querySelector('ion-backdrop')!)
        .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');
  
      const wrapperAnimation = this.animationCtrl
        .create()
        .addElement(root.querySelector('.modal-wrapper')!)
        .keyframes([
          this.DBservice.ismobile ? { offset: 0, opacity: '0.09', transform: 'translateY(100%)' } : { offset: 0, opacity: '0.09', transform: 'translateX(100%)' },
          this.DBservice.ismobile ? { offset: 1, opacity: '1', transform: 'translateY(0)' } : { offset: 1, opacity: '1', transform: 'translateX(0)' },
        ]);
      return this.animationCtrl
        .create()
        .addElement(baseEl)
        .easing('ease-out')
        .duration(500)
        .addAnimation([backdropAnimation, wrapperAnimation]);
    };
  
    leaveAnimation = (baseEl: HTMLElement) => {
      return this.enterAnimation(baseEl).direction('reverse');
    };
  

  async attach_images(){
    // this.product = this.product == undefined ? this.DBservice.product_info.product : this.product;
    let temp = this.product.images
    const modal = await this.modalCtrl.create({
      component : AttributesAddImgComponent,
      // cssClass : 'category-selection-popup',
      cssClass : 'add-attribute-modal',
      componentProps : {
        product_info : this.product,
      }
    })

    await modal.present();
  }

  async open_gallery(data,index){
     this.product = this.product == undefined ? this.DBservice.product_info.product : this.product;
    let temp = this.product.images
    // this.DBservice.image_page = page_name;
    const modal = await this.modalCtrl.create({
      component : ImageGalleryPage,
      cssClass : 'add-image-modal',
      componentProps : {
        product_info : this.product,
        product_id : this.product.name,
        current_img : data,
        current_img_id : index
      }
    })

    await modal.present();

  }


  async add_image(){
    this.product = this.product == undefined ? this.DBservice.product_info.product : this.product;
    let temp = this.product.images
    // this.DBservice.image_page = page_name;
    const modal = await this.modalCtrl.create({
      component : AddImagePage,
      cssClass : 'add-image-modal',
      componentProps : {
        product_info : this.product,
        product_id : this.product.name,
      }
    })

    await modal.present();

    await modal.onWillDismiss().then(res => {
      if(res.data == 'success'){
        console.log(this.product)
        // this.upload_image(this.product.product_images);
      } 
    })
    
    // if(this.product_form.status == 'VALID'){

    //   await modal.onWillDismiss().then(res =>{
    //     if(res.data == 'success'){
    //       this.post_product();
    //     } else {
    //       this.product.images = temp
    //     }
    //   })
    // } else {
    //     this.DBservice.alert('Please save your document to add image')
    // }

  }


  async upload_image(product_images) {
    let loader = await this.loadingCtrl.create({
      spinner: 'bubbles',
      message: 'Loading Please Wait...'
    });

        await loader.present();
        this.DBservice.uploadfiles({ "products" :  product_images }).subscribe(data => {
          console.log(data)
          if(data.message == 'success'){
            this.modalCtrl.dismiss('success');
              setTimeout(() => {  loader.dismiss(); }, 50);
            
            if(this.route_id){
              this.get_product_detail1(this.route_id,loader)
            }else{
              setTimeout(() => {  loader.dismiss(); }, 50);
            }
            
          }
        },err => {
          console.error(err);
          setTimeout(() => {  loader.dismiss();  }, 50);
        })
    

  }

  async upload_attri_image(product_images) {
    let loader = await this.loadingCtrl.create({
      spinner: 'bubbles',
      message: 'Loading Please Wait...'
    });

        await loader.present();
        this.DBservice.upload_attribute_files({ "variants" :  product_images }).subscribe(data => {
          console.log(data)
          setTimeout(() => {  loader.dismiss(); }, 50);
          if(data.message.status == 'success'){
            this.modalCtrl.dismiss('success');

            if(this.route_id){
              this.get_product_detail1(this.route_id,loader)
            }else{
              
            }
            
          }
        },err => {
          console.error(err);
          setTimeout(() => {  loader.dismiss();  }, 50);
        })
    

  }

  get_product_detail1(id,loader){
    // var data = {  Product: id  }
    var data = id;
    this.DBservice.get_product(data).subscribe(data => {
      this.product.product_images = data.message.product_images;
     }, error => {  console.log(JSON.stringify(error.json()))});
     setTimeout(() => {  loader.dismiss(); }, 50);
  }

  async open_brands(){
    const modal = await this.modalCtrl.create({
      component: ProductBrandsPage,
      cssClass: 'report-popup',
      componentProps:{
        product : this.product
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if(data && data.length != 0){
      // console.log(data)
      this.product.product_brands = data;
    //   if (this.product.product_brands.length != 0) {
    //     let cat = this.product.product_brands.find(t => {
    //       if (t.brand_name == data.datas.brand_name)
    //         return true
    //     });
    //     if (!cat) 
    //       this.product.product_brands.push(data.datas);
    //   } else {
    //     this.product.product_brands.push(data.datas);
    //   }
    // } else {
    //   let cat = this.product.product_brands.find(t => {
    //     if (t.brand_name == data.datas.brand_name) {
    //       return true
    //     }
    //   });
    //   if (!cat) 
    //     this.product.product_brands.push(data.datas);
    }
  }

  close_brand(data,index){
    this.product.product_brands.splice(index,1);
  }


  async category_modal(){
    const modal = await this.modalCtrl.create({
      component : CategorySelectionComponent,
      // cssClass : 'add-attribute-modal',
      cssClass : 'left-side-variants',
      componentProps : {
        category : this.categorylist,
        product : this.product
      }
    })
    await modal.present();
    
    // if(this.product_form.status == 'VALID'){
    //   const modal = await this.modalCtrl.create({
    //     component : CategorySelectionComponent,
    //     cssClass : 'category-selection-popup',
    //     componentProps : {
    //       category : this.categorylist,
    //       product : this.product
    //     }
    //   })
  
    //   await modal.present();
      await modal.onWillDismiss().then(res =>{
        if(res.data){
          // console.log("category mapping",res.data)
          this.product.product_categories = res.data
          // this.post_product();
        }
      })
    // } else {
    //   this.DBservice.alert('Please add product after you will asign the category')
    // }
  }

  

  async open_return(){
    const modal = await this.modalCtrl.create({
      component : ReturnPolicyPage,
      // cssClass : 'add-attribute-modal',
      cssClass : 'left-side-variants',
      
    })
    await modal.present();
    let data = await modal.onWillDismiss();
    if(data && data['data'] && data['data']['status'] == 'success'){
      this.policy_list = []
      delete data['status']
      this.policy_list.push(data['data'])
    }
  }

  async open_replacement(){
    const modal = await this.modalCtrl.create({
      component : ReplacementPolicyPage,
      // cssClass : 'add-attribute-modal',
      cssClass : 'left-side-variants',
      
    })
    await modal.present();
    let data = await modal.onWillDismiss();
    if(data && data['data'] && data['data']['status'] == 'success'){
      this.replacement_list = []
      delete data['status']
      this.replacement_list.push(data['data'])
      // console.log(this.policy_list)
    }
    // if(data){
    //   console.log(data)
    // }
   

  }

  category_map(item,type){
    
  if(type == 'category_map'){

    let data = [{'category_name' : item.product_category_name,'category':item.name}]
    this.product.product_categories = [...this.product.product_categories,...data];
   
    this.search_txt = '';
    let add_animate = item.product_category_name + 'added successfully'
    this.DBservice.alert_animate.next(add_animate);
   
    let d = this.product.product_categories.find(res=> item.product_category_name == res.category_name)

    if(d){ 
      this.categorylist = this.categorylist.filter((item) => item.product_category_name !== d.category_name);      
      item.show = false;
     } else{
       item.show = true;
     }

  }else if(type == 'brands'){
      
    //Modified on-16/02/23(john)
    let data = [{'brand_name' : item.brand_name,'name':item.name}]
    this.product.product_brands = [...this.product.product_brands,...data];
   
    this.search_txt_brands = '';
    let add_animate = item.brand_name + 'added successfully'
    this.DBservice.alert_animate.next(add_animate);
   
    let d = this.product.product_brands.find(res=> item.brand_name == res.brand_name)

    if(d){ 
      this.brands_list = this.brands_list.filter((item) => item.brand_name !== d.brand_name);      
      item.show = false;
     } else{
       item.show = true;
     }


  }


    // this.search_bar = false
  }

  get_search_values(type){
   
    if(type == 'category_map'){
      this.search_array = this.categorylist;
      this.search_bar = true
    }else if(type == 'brands'){
      this.brands_search_array = this.brands_list;
      this.search_bar_brands = true
    }
    
  }
  

  search_value(event,type){
  
    if(type == 'category_map'){
      
      this.search_bar = true;
      this.categorylist.map(item=>{

        let d = this.product.product_categories.find(res=> item.product_category_name == res.category_name)

        if(d){ 
         this.categorylist = this.categorylist.filter((item) => item.product_category_name !== d.category_name);      
         item.show = false;
        } else{
         item.show = true;
        }
      })

      this.search_array = this.categorylist; 
    
      if(event.detail.value != '' && event.detail.value != undefined){
       let searchTerm = event.detail.value;
       this.search_array = this.categorylist.filter(obj => (obj.product_category_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) || (obj.sku ? obj.sku.indexOf(searchTerm.toLowerCase()) > -1 : '')) 
      }else{
       
      }

    }else if(type == 'brands'){
    
       this.search_bar_brands = true;
  
       this.brands_list.map(item=>{
    
       let d = this.product.product_brands.find(res=> item.brand_name == res.brand_name)

        if(d){ 
         this.brands_list = this.brands_list.filter((item) => item.brand_name !== d.brand_name);      
         item.show = false;
        }else{
         item.show = true;
        }
      })

     this.brands_search_array = this.brands_list; 
   
     if(event.detail.value != '' && event.detail.value != undefined){
       let searchTerm = event.detail.value;
       this.brands_search_array = this.brands_list.filter(obj => (obj.brand_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) || (obj.sku ? obj.sku.indexOf(searchTerm.toLowerCase()) > -1 : '')) 
     }else{
       
     }

    }

  }

  remove(category,index,type){
    
    if(type == 'category_map'){
      
      // let data = [{name: category[index].category,product_category_name: category[index].category_name,show: true,products:[]}]
      // this.categorylist = [...this.categorylist,...data];
      category.splice(index, 1);
      // console.log(this.categorylist)

    }else if(type == 'brands'){
      
      let data = [{brand: category[index].brand,brand_name: category[index].brand_name,show: true}]
      this.brands_list = [...this.brands_list,...data];
      category.splice(index, 1);

    }
  
  }

  get__filters(category,obj){
    category.map(res=>{
      if(res.category_name == obj.product_category_name){
        res.show = false;
      }else{
        res.show = true
      }
    })
  }



   load_product_Values(){
    Object.keys(this.product_form.controls).forEach(key => {
     


      let v = this.product[key]

      if(key == 'inventory_method' || key == 'enable_shipping' || key == 'free_shipping' || key == 'percentage_or_amount' || key == 'enable_preorder_product' || key == 'weight' || key == 'has_variants'){
        this.form_data.map(res => {
          res.group_fileds.map(value => {

            if(key == 'inventory_method' && (value.name == 'maximum_order_qty' || value.name == 'stock')){
              v == 'Dont Track Inventory' ?  value.hidden = true : value.hidden = false
            }

            // console.log(key)
            // console.log(value)
            // console.log(v)
            // if(key == 'weight'){

            // }

            if(key == 'weight' && (value.name == 'weight' && this.product.has_variants == 1)){
              value.hidden = true;
              // !v ? value.hidden = true : value.hidden = false
            }

            if(key == 'has_variants' && (value.name == 'has_variants')){
              value.disabled = true;
              // v ? value.disabled = true : value.disabled = false
            } 

            if(key == 'enable_shipping' &&  (value.name == 'free_shipping' || value.name == 'additional_shipping_cost')){
                !v ?  value.hidden = true : value.hidden = false
            } 
            
            if(key == 'free_shipping' && value.name == 'additional_shipping_cost'){
                v ?  value.hidden = true : value.hidden = false
            } 

            if( key == 'enable_preorder_product' && ( value.name == 'percentage_or_amount' || value.name == 'preorder_percent' || value.name == 'preorder_amount')) {
              !v ?  value.hidden = true : value.hidden = false
            }

            if( key == 'percentage_or_amount' && value.name == 'preorder_percent' ){
               this.product['enable_preorder_product'] && v == 'Preorder Percentage'  ? (value.hidden = false,value.required = true )  : (value.required = false,value.hidden = true)  
            } 

            if( key == 'percentage_or_amount' && value.name == 'preorder_amount') {
              this.product['enable_preorder_product'] && v == 'Preorder Amount'  ?  (value.hidden = false,value.required = true ) : (value.required = false,value.hidden = true) 
            } 

          })
        })
      }
      this.product_form.get(key).setValue(this.product[key])
      // console.log(key+" : ",this.product[key])
      // console.log(key+" : ", this.product_form.get(key))
    });

    this.chf.detectChanges();

    // let v = {}

    // this.form_data.map(res =>{
    //   res.group_fileds.map(op =>{
    //     v[op.name] = new FormControl( this.product[op.name] ,[])
    //   })
    // })

    // this.product_form =  this.formBuilder.group(v)
   }

  //  check_conditions(){
  //   let v = this.product[key]
  //   if( v == 'maximum_order_qty' || v == 'stock'){
  //     v.value == 'Dont Track Inventory' ?  value.hidden = true : value.hidden = false
  //   } 
  //  }

  change(){
    this.attibute_list.push({
            product_attribute:'',
            is_required:'Yes',
            control_type:'',
            display_order:'',
            attribute:''
          })
    // console.log(this.attibute_list)
  }


   delete(index){
      // if(this.attibute_list.length)
      this.attibute_list.splice(index,1)
   }


   get_categorylist() {
        var data = {
          business:localStorage['business']
          // name: localStorage.restaurantId,
           // domain: this.DBservice.domain
        }
        this.DBservice.get_categories(data).subscribe(data => {
            // console.log(data);
            this.search_array = data.message; 
            this.categorylist = data.message;
            // this.storage.set("get_all_category",data.message);
            // this.getsearch();
          }, error => {
            console.log(JSON.stringify(error.json()));
          });
  }

  get_speficication(){
    this.DBservice.get_specification_group().subscribe(data => { 
      this.specifications.specifications_group = data.data;
      this.DBservice.specifications_group = data.data;
     }, error => {});
  }

  get_speficication_attr(){
    this.DBservice.get_specification_attributes().subscribe(data => { 
      this.specifications.specifications_attributes = data.data;
      this.DBservice.specifications_attributes = data.data;
     }, error => {});
  }

  get_brands_list() {
 
    this.DBservice.get_brands().subscribe(data => {
        this.brands_search_array = data.message; 
        this.brands_list = data.message;
        this.DBservice.get_product_brands = data.message;
        // this.storage.set("get_all_category",data.message);
        // this.getsearch();
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
}


  insert_product(item,text){
    this.DBservice.add_menu_item(item).then(res => {

          if(res.message.status == 'failed')
          {
            var d = JSON.parse(res._server_messages);
            var d1 = JSON.parse(d);
            // this.DBservice.alert(d1.message)
          }
          else{
            this.navCtrl.pop()
            // this.modalService.dismissAll()
            // this.get_categorylist();
            
          }
          // console.log(res)
          // this.modalCtrl.dismiss(res)
        })
  }



  sidebar = [
    {
      title : 'Images',
      name : 'images',
      icon: ''
    },
    {
      title : 'Product Info',
      name : 'product_info',
      icon: ''
    },
    // {
    //   title :   'Inventory',
    //   name : 'inventory',
    //   icon: ''
    // },

    // {
    //   title : 'Category Mapping',
    //   name : 'category_mapping',
    //   icon: ''
    // },
    {
      title : 'Variants',
      name : 'variants',
      icon: ''
    },
    // {
    //   title : 'Shipping Info',
    //   name : 'shipping_info',
    //   icon: ''
    // },
    // {
    //   title : 'Return Policy',
    //   name : 'return_policy',
    //   icon: ''
    // },
    // {
    //   title : 'Replacement Policy',
    //   name : 'replacement_policy',
    //   icon: ''
    // },
    {
      title :   'Brands',
      name : 'brands',
      icon: ''
    },

    // {
    //   title : 'Specifications',
    //   name : 'specifications',
    //   icon: ''
    // },
    // {
    //   title : 'SEO',
    //   name : 'seo',
    //   icon: ''
    // },


    // {
    //   title :   'Shipping Info',
    //   name : 'shipping_info',
    //   icon: ''
    // },
    // {
    //   title :  'Brands',
    //   name : 'brands',
    //   icon: ''
    // },
    // {
    //   title : 'Model',
    //   name : 'modal',
    //   icon: ''
    // },
 
    // {
    //   title : 'Specifications',
    //   name : 'specifications',
    //   icon: ''
    // },
    // {
    //   title :   'Promotions',
    //   name : 'promotions',
    //   icon: ''
    // },    
  ]


  async edit_spec(items,i,item){
    this.DBservice.specification_data = item;
      const modal = await this.modalCtrl.create({
        component: SpecificationAttributesPage,
        cssClass : 'left-side-variants',
        componentProps : {
          specification : items,
          title :"Edit",
          index : i
        }
      });
      await modal.present();
      const data = await modal.onWillDismiss();
      if(data && data.data && data.data.datas){
        this.specification[i] = data.data.datas;
      }
    }


  async add_specification(specification){
    // let datas = [{'option_value':event,'price':0,'quantity':0}]
    // item.options = [...item.options,...datas];
    this.DBservice.specification_data = {};
    const modal = await this.modalCtrl.create({
      component: SpecificationAttributesPage,
      cssClass : 'left-side-variants',
      componentProps : {
        specification : specification,
        title : "Add"
      }
    });
    await modal.present();
    const data = await modal.onWillDismiss();
    // console.log(data);
    if(data && data.data && data.data.datas){

      if(this.specification && this.specification.length != 0){
        let value = this.specification.find((res:any)=>{ return ((res.spec_group_name == data.data.datas.spec_group_name) && (res.specification_attribute == data.data.datas.specification_attribute))})
        if(!value){
          this.specification.push(data.data.datas);
        }else{
         let obj = { alert:true, item:'The selected specification was already in added list', bg_color:this.DBservice.alert_bg}
         this.DBservice.ismobile ? this.DBservice.auto_close_alert('The selected specification was already in added list') : this.DBservice.alert_animate.next(obj);
        }
      }else{
        this.specification.push(data.data.datas);
      }

      // if(this.specification && this.specification.length != 0){
      //   let value = this.specification.find((res:any)=>{
      //     if(res.spec_group_name == data.data.datas.spec_group_name && res.specification_attribute == data.data.datas.specification_attribute){
      //       return true;
      //     }
      //   })
      //   if(!value){
      //     this.specification.push(data.data.datas);
      //   }
      // }else{
      //   this.specification.push(data.data.datas);
      // }
    }
    // console.log(specification)
  }

  modify_specs(data,index,type){
    if(type == "edit"){
      this.add_specification(data);
      this.DBservice.specification_data = data;
    }else if(type == "delete"){
      // console.log(data,index,type)
      this.specification.splice(index,1);
      this.DBservice.specification_data = {};
    }
  }


  get_remove_add_mandorty(eve){
    let res = eve;
    let value = '';
    res.required ? this.product_form.setControl(res.name, this.formBuilder.control(value, [Validators.required])) : this.product_form.setControl(res.name, this.formBuilder.control(value));
    // console.log(this.product_form)
  }


  post_product(){
    
    this.submitted = true
    // console.log(this.categorylist);
    let product_images  = this.product.product_images.filter(res=> res.image_upload == true);
    let attribute_product_images:any = [];
    if(this.product.variant_combination != undefined){
      this.product.variant_combination.map(res=>{
        delete res.image;
        let check =[];
        let images_list:any={};
        // console.log(res.image_list)
        res.image_list && res.image_list.length > 0 ? check  = res.image_list.filter(res=> res.image_upload == true) : '';
        // res.image_list && res.image_list.length > 0 ? check  = res.image_list.find(res=> res.image_upload == true) : '';
        if(check && check.length > 0){
          images_list.docname =  res.name
          images_list.doctype = "Product Variant Combination"
          images_list.image_list = check
          attribute_product_images = [...attribute_product_images,images_list]
        }
      })
    }

    // console.log(this.product_form);
    // let attribute_product_images  = this.product.variant_combination.filter(res=> res.image_upload == true);
    if(this.product_form.status == 'VALID'){
      if(this.title == 'Add' && this.product_form.value.has_variants == 0){
        this.product.product_attributes = [];        
        this.product.variant_combination = [];        
        this.product.attribute_options = [];        
      }

      // if()
      if(this.product.variant_combination && this.product.variant_combination.length > 0){
        let check = this.product.variant_combination.filter(obj => obj.uom == null)
        if(this.title == 'Add' && check && check.length > 0){
          check.map(res =>{
            res.uom = this.product_form.value.uom
          })
        }
        // if(check && check.length > 0){
        //   this.DBservice.auto_close_alert('Please enter the UOM');
        //   this.bulk_edit_combination();
        //   return;
        // }
      }

      if(this.product.variant_combination && this.product.variant_combination.length > 0){
        let check = this.product.variant_combination.filter(obj => obj.weight == 0)
        if(check && check.length > 0){
          this.DBservice.auto_close_alert('Please enter the weight');
          this.bulk_edit_combination();
          return;
        }
      }



      // this.route_id ? null : this.upload_image(this.product.product_images);
      let data = this.product_form.value
      
      // data.price = Number(data.price)
      // data.old_price = Number(data.old_price)
      // data.stock = Number(data.stock)
      data.product_sequence = Number(data.product_sequence)

      data.weight = Number(data.weight)
      data.gross_weight = Number(data.gross_weight)
      data.additional_shipping_cost = Number(data.additional_shipping_cost)
      data.domain = localStorage['active_domain']
      data.name = this.product.name
      let options:any=[];
      this.product.product_attributes.map(res=>{
        // console.log(res)
        res.control_type = res.control_type ? res.control_type :'Radio Button List';
        if(res.options && res.options.length > 0){
          res.options.map((op,i) => {
            op.attribute = res.product_attribute
            op.display_order = i
            options.push(op);
            // op.is_pre_selected = res.is_pre_selected
          })
        }
        res.attribute_option = res.options ? JSON.stringify(res.options) : [];
        res.parent = data.name;
        res.parentfield = "product_attributes";
        res.parenttype ="Product";
        res.idx = this.product.idx;
        res.docstatus = this.product.docstatus;
        delete res.is_active;
        delete res.all_options;
        delete res.option_values;
        delete res.options;
      })
      if(this.product.variant_combination != undefined){
        this.product.variant_combination.map(res=>{
          delete res.image_list;
        })
       }

      data.product_attributes = this.product.product_attributes
      data.attribute_options = options && options.length >0 ? options : this.product.attribute_options
      // data.attribute_options = this.product.product_attributes
      data.product_categories = this.product.product_categories
      data.variant_combination = this.product.variant_combination
      data.images = this.product.images
      data.product_variant = this.product.product_variant
      data.product_brands == undefined ? data.product_brands = [] : data.product_brands
      data.product_brands = this.product.product_brands
      data.inventory_method = data.inventory_method ? data.inventory_method : 'Dont Track Inventory';
      // data.stock = this.title == 'Add' ? data.stock : data.stock;
      data.uom = data.uom;
      data.weight = data.weight;
      // data.return_policy = (this.policy_list && this.policy_list.length != 0) ? this.policy_list[0].name : ''
      if(this.policy_list && this.policy_list.length != 0){
        data.return_policy = this.policy_list[0].name
        data.return_title = this.policy_list[0].heading
        data.return_description = this.policy_list[0].description
      }
      if(this.replacement_list && this.replacement_list.length != 0){
        data.replacement_name = this.replacement_list[0].name
        data.replacement_title = this.replacement_list[0].heading
        data.replacement_description = this.replacement_list[0].description
      }
      data.product_specification_attributes = this.product.product_specification_attributes
      // console.log(JSON.stringify(data));
      // data.product_brands = data.product_brands ? data.product_brands = this.product.product_brands : data={ product_brands:this.product.product_brands }
      if(this.title == 'Add'){
        this.DBservice.insert_products(data).subscribe(res =>{

          // console.log('test-----------',data);

          if(res.message.status == 'Success'){
              // console.log(attribute_product_images)
              
              if(this.title == 'Add'){
                product_images.map((res_data) => {
                  res_data.docname ? '' : res_data.docname = res.message.product_id
                })

                this.title = 'Edit'
                // attribute_product_images.map((res_data) => {
                //   res_data.docname ? '' : res_data.docname = res.message.product.name
                // })
              }else{
                if(this.is_not_shown) {
                  this.DBservice.get_products_list();
                  this.DBservice.ismobile ? this.modalCtrl.dismiss() : null
                }
              }

              product_images.length != 0 ? this.upload_image(product_images) : null
              attribute_product_images.length != 0 ? this.upload_attri_image(attribute_product_images) : null
              // let alert = this.products?'Product added':'Product Updated'
              // this.DBservice.alert(alert);
              this.DBservice.alert(res.message.message);
              // this.product = res.message.product;
              // this.location.replaceState("/addproduct?id=" + this.product.name);
              this.router.navigateByUrl('/product-list');
              // this.product.product_variant = this.product.variant_combination
              // this.load_product_Values();
              

              // if(this.product.product_categories.length !=0 && res.message.product.is_active){
              //     this.categorylist.map((cat_list)=>{
              //     res.message.product.product_categories.map((cat)=>{
              //         if(cat.category == cat_list.name){
              //           if(this.title == 'Add'){
              //             let data = {
              //               image : res.message.product.image,
              //               name : res.message.product.name,
              //               item : res.message.product.item,
              //               price : res.message.product.price,
              //               sku : res.message.product.sku,
              //               stock : res.message.product.stock
              //             }
              //             cat_list.products.push(data);
              //           }
              //           else{
              //           if(cat_list.products){
              //             cat_list.products.map((product)=>{
              //               if(product.name == res.message.product.name){
              //                   product.image = res.message.product.image
              //                   product.item  = res.message.product.item
              //                   product.price = res.message.product.price
              //                   product.sku = res.message.product.sku
              //                   product.stock = res.message.product.stock
              //               }
              //             })
              //           }
              //           }
              //         }
              //       })
              //     })
                
              // }
          }else if(res.message.status == 'failed'){
              if(res._server_messages){
                var d = JSON.parse(res._server_messages);
                var d1 = JSON.parse(d);
                this.DBservice.alert(d1.message);
              }
              else{
                this.DBservice.alert(res.message.status);
              }
          }
          // console.log(res)
        })
      }else{
        data.product = data.name;
        data.doctype = "Product";
        delete data.name;

    
        if(this.product.product_categories && this.product.product_categories.length != 0 && data.product_categories && data.product_categories.length != 0){
          data.product_categories.map(r=>{
            r.childname = r.name ? r.name : null
            let value = this.product.product_categories.find(res=> res.category == r.category);
            if(value){
             r.childname = value.name ? value.name : null
            }
          })
        }

        if(this.product.product_attributes && this.product.product_attributes.length != 0 && data.product_attributes && data.product_attributes.length != 0){
          data.product_attributes.map(r=>{
            r.childname = r.name ? r.name : null
            
          })
        }

        if(this.product.variant_combination && this.product.variant_combination.length != 0 && data.variant_combination && data.variant_combination.length != 0){
          data.variant_combination.map(r=>{
            r.childname = r.name ? r.name : null
          })
        }

        this.DBservice.update_products(data).subscribe(res =>{
           if(res && res.message && res.message.product){
            let alert_msg = 'Product was updated successfully. Waiting for admin approval'
            this.DBservice.alert(alert_msg);
              this.router.navigateByUrl('/product-list');
              this.reset_form();
              this.title = 'Add';
            // product_images.map((res_data) => {
            //   res_data.docname = res.message.name
            //   res_data.doctype = 'Product Update Approval'
            // })
            product_images.length != 0 ? this.upload_image(product_images) : null
           }
        })
      }
      
    } 
    // else if(this.product.product_categories.length == 0){
    //   this.DBservice.alert('Add at least any one of category');
    // }
    else {
      this.current_value = 'product_info'
    }
  }

  async setting(){
    const modal = await this.modalCtrl.create({
      component : ProductSettingsPage,
      cssClass : 'add-attribute-modal',
      componentProps : {
        
      }
    })

    await modal.present();
    await modal.onWillDismiss().then(res =>{
        
        // if(res.data && res.data == 'success'){
          // this.product = this.product;
        // }
    })
  }



  changeTest(event,value){
    value = event.checked;
  }



  save_all_price(variants,check){
    variants.price = variants.price ? variants.price : 0;
    variants.stock = variants.stock ? variants.stock : 0;
    variants.variant_combination.map(res=>{
      res.price = variants.price;
      res.stock = variants.stock;
    })
    check = false;
  }

  check_box__(){
    this.check_box =! this.check_box;
  }


  form_data:any =  [
    {
      group_title : 'Product Info',
      mapped_by:'product_info',
      group_fileds :[
            {
              label :'Product Name',
              input_type: 'input',
              type : 'text',
              name :'item',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
              tooltip: 'Name of the product',
              width: this.DBservice.ismobile ? 'full' : undefined
            },
            // {
            //   label :'Price',
            //   input_type: 'input',
            //   // type : 'text',
            //   type : 'number',
            //   name :'price',
            //   placeholder : '',
            //   required : true,
            //   hidden: false,
            //   value : '',
            //   tooltip: 'The selling price of the product'
            // },
            // {
            //   label :'Old Price(MRP)',
            //   input_type: 'input',
            //   // type : 'text',
            //   type : 'number',
            //   name :'old_price',
            //   placeholder : '',
            //   required : false,
            //   hidden: false,
            //   value : ''
            // },
            // {
            //   label :'SKU',
            //   input_type: 'input',
            //   type : 'text',
            //   name :'sku',
            //   placeholder : '',
            //   required : false,
            //   hidden: false,
            //   value : '',
            //   disabled:true
            // },
            {
              label :'Weight (In KG)',
              input_type: 'input',
              type : 'number',
              name :'weight',
              placeholder : '',
              required : true,
              hidden: false,
              value : '',
              disabled:false
            },
            {
              label : "UOM",
              input_type: 'dropdown',
              type : 'text',
              name :'uom',
              placeholder : 'UOM',
              required : true,
              hidden: false,
              value : '',
              // dropdown_options:this.uom_list,
              dropdown_api: 'UOM',
              tooltip: '',
              // width: this.DBservice.ismobile ? 'full' : undefined
            },
            {
              label :'Has Variants?',
              input_type: 'checkbox__',
              type : 'text',
              name :'has_variants',
              placeholder : '',
              required : false,
              hidden: false,
              value : 0,
              disabled:false
            },
            {
              label :'Is Active?',
              input_type: 'checkbox__',
              type : 'text',
              name :'is_active',
              placeholder : '',
              required : false,
              hidden: false,
              value : 1
            },
            {
              label :'Tax Template',
              input_type: 'dropdown',
              type : 'text',
              name :'tax_category',
              placeholder : '',
              required : false,
              hidden: true,
              value : '',
              dropdown_api: 'Product Tax Template',
              width: this.DBservice.ismobile ? 'full' : undefined
            },
            // {
            //   label : "Tax Template",
            //   input_type: 'dropdown',
            //   type : 'text',
            //   name :'tax_category',
            //   placeholder : 'Tax Template',
            //   required : false,
            //   hidden: false,
            //   value : '',
            //   options:[{'name':'Product Tax Template'}],
            //   tooltip: '',
            //   },
            
            {
              label :'Is Featured Product? ',
              input_type: 'checkbox__',
              type : 'text',
              name :'display_home_page',
              placeholder : '',
              required : false,
              hidden: true,
              value : 0
            },
            // {
            //   label :'Is Bundle Item',
            //   input_type: 'checkbox__',
            //   type : 'text',
            //   name :'is_bundle_item',
            //   placeholder : '',
            //   required : false,
            //   hidden: false,
            //   value : 0
            // },
            // {
            //   label :'Is gift card',
            //   input_type: 'checkbox__',
            //   type : 'text',
            //   name :'is_gift_card',
            //   placeholder : '',
            //   required : false,
            //   hidden: false,
            //   value : 0
            // },
            // {
            //   label :' Is Subscription Item',
            //   input_type: 'checkbox__',
            //   type : 'text',
            //   name :'is_subscription_item',
            //   placeholder : '',
            //   required : false,
            //   hidden: false,
            //   value : 0
            // },
            // {
            //   label :'Cut List Sequence',
            //   input_type: 'input',
            //   type : 'text',
            //   name :'product_sequence',
            //   placeholder : '',
            //   required : false,
            //   hidden: false,
            //   value : ''
            // },
            {
          label :'Short Description',
          input_type: 'textarea',
          type : 'text',
          name :'short_description',
          placeholder : '',
          required : false,
          hidden: false,
          value : '',
          width: this.DBservice.ismobile ? 'full' : undefined
        },
        // {
        //   label :'Description',
        //   input_type: 'textEditor',
        //   // input_type:'textarea',
        //   type : 'text',
        //   name :'full_description',
        //   placeholder : '',
        //   required : false,
        //   hidden: true,
        //   value : ''
        // },
      ]
    },
    // {
    //   group_title : 'Shipping Info',
    //   mapped_by: 'shipping_info',
    //   group_fileds : [
    //     {
    //       label :'Enable Shipping',
    //       input_type: 'checkbox__',
    //       type : 'text',
    //       name :'enable_shipping',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : 0
    //     },
    //     {

    //       label : "UOM",
    //       input_type: 'dropdown',
    //       type : 'text',
    //       name :'uom',
    //       placeholder : 'UOM',
    //       required : true,
    //       hidden: false,
    //       value : '',
    //       // dropdown_options:this.uom_list,
    //       dropdown_api: 'UOM',
    //       tooltip: '',
    //       // width: this.DBservice.ismobile ? 'full' : undefined
    //     },
    //     {
    //       label :'Enable Free Shipping',
    //       input_type: 'checkbox__',
    //       type : 'text',
    //       name :'free_shipping',
    //       placeholder : '',
    //       required : false,
    //       hidden: true,
    //       value : 0
    //     },
    //     {
    //       label :'Additional Shipping Cost',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'additional_shipping_cost',
    //       placeholder : '',
    //       required : false,
    //       hidden: true,
    //       value : ''
    //     },
    //     {
    //       label :'Net Weight (In gms)',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'weight',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : ''
    //     },
    //     {
    //       label :'Gross Weight (In gms)',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'gross_weight',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : ''
    //     },
    //   ]
    // },
    // {
    //   group_title : 'PREORDER',
    //   mapped_by:'product_info',
    //   group_fileds :[
    //         {
    //           label :'Enable Preorder To Product',
    //           input_type: 'checkbox__',
    //           type : 'text',
    //           name :'enable_preorder_product',
    //           placeholder : '',
    //           required : false,
    //           hidden: false,
    //           value : 0
    //         },
    //         // {
    //         //   label :'Percentage or Amount',
    //         //   input_type: 'dropdown',
    //         //   type : 'text',
    //         //   name :'percentage_or_amount',
    //         //   placeholder : '',
    //         //   required : false,
    //         //   hidden: true,
    //         //   value : 'Preorder Percentage',
    //         //   dropdown_options :[
    //         //     {
    //         //       text : 'Preorder Percentage'
    //         //     },
    //         //     {
    //         //       text : 'Preorder Amount'
    //         //     },
    //         //   ]
    //         // },
    //         {
    //           label : "Percentage or Amount",
    //           input_type: 'dropdown',
    //           type : 'text',
    //           name :'percentage_or_amount',
    //           placeholder : 'Percentage or Amount',
    //           required : false,
    //           hidden: true,
    //           value : 'Preorder Percentage',
    //           options:[{'name':'Preorder Percentage'},{'name':'Preorder Amount'}],
    //           tooltip: '',
    //           },
    //         {
    //           label :'Preorder Percent',
    //           input_type: 'input',
    //           type : 'text',
    //           name :'preorder_percent',
    //           placeholder : '',
    //           required : false,
    //           hidden: true,
    //           value : ''
    //         },
    //         {
    //           label :'Preorder Amount',
    //           input_type: 'input',
    //           type : 'text',
    //           name :'preorder_amount',
    //           placeholder : '',
    //           required : false,
    //           hidden: true,
    //           value : ''
    //         },
    //         // {
    //         //   label :'Stock UOM',
    //         //   input_type: 'dropdown',
    //         //   type : 'text',
    //         //   name :'stock_uom',
    //         //   placeholder : '',
    //         //   required : false,
    //         //   hidden: false,
    //         //   value : '',
    //         //   dropdown_api : 'UOM'
    //         // },
    //         {
    //           label : "Stock UOM",
    //           input_type: 'dropdown',
    //           type : 'text',
    //           name :'stock_uom',
    //           placeholder : 'Percentage or Amount',
    //           required : false,
    //           hidden: false,
    //           value : 'UOM',
    //           options:[{'name':'UOM'}],
    //           tooltip: '',
    //           },
    //   ]
    // },
    {
      group_title : 'DESCRIPTION',
      mapped_by:'product_info',
      group_fileds : [
        // {
        //   label :'Short Description',
        //   input_type: 'textarea',
        //   type : 'text',
        //   name :'short_description',
        //   placeholder : '',
        //   required : false,
        //   hidden: false,
        //   value : ''
        // },
        {
          label :'Description',
          input_type: 'textEditor',
          // input_type:'textarea',
          type : 'text',
          name :'full_description',
          placeholder : '',
          required : false,
          hidden: false,
          value : ''
        },
      ]
    },
    // {
    //   group_title : 'Inventory',
    //   mapped_by:'inventory',
    //   group_fileds : [
    //     // {

    //     //   label : "Inventory Method",
    //     //   input_type: 'dropdown',
    //     //   type : 'text',
    //     //   name :'inventory_method',
    //     //   placeholder : 'Inventory Method',
    //     //   required : false,
    //     //   hidden: false,
    //     //   value : 'Track Inventory',
    //     //   // options:[{'name':'Track Inventory'},{'name':'Dont Track Inventory'},{'name':'Track Inventory By Product Attributes'}],
    //     //   dropdown_options:[{'text':'Track Inventory'},{'text':'Dont Track Inventory'},{'text':'Track Inventory By Product Attributes'}],
    //     //   tooltip: '',
    //     //   width: this.DBservice.ismobile ? 'full' : undefined

    //     //   // label :'Inventory Method',
    //     //   // input_type: 'dropdown',
    //     //   // type : 'ionic',
    //     //   // name :'inventory_method',
    //     //   // placeholder : '',
    //     //   // required : false,
    //     //   // hidden: false,
    //     //   // value : 'Track Inventory',
    //     //   // dropdown_options :[
    //     //   //   {
    //     //   //     text : 'Dont Track Inventory'
    //     //   //   },
    //     //   //   {
    //     //   //     text : 'Track Inventory'
    //     //   //   },
    //     //   //   {
    //     //   //     text : 'Track Inventory By Product Attributes'
    //     //   //   }
    //     //   // ]
    //     // },
    //     // {
    //     //   label :'Stock Qty',
    //     //   input_type: 'input',
    //     //   type : 'text',
    //     //   name :'stock',
    //     //   placeholder : '',
    //     //   required : false,
    //     //   hidden: false,
    //     //   value : '1',
    //     //   width: this.DBservice.ismobile ? 'full' : undefined
    //     // },
    //     {
    //       label :'Disable Add To Cart Button',
    //       input_type: 'checkbox__',
    //       type : 'text',
    //       name :'disable_add_to_cart_button',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : 0
    //     },
    //     {
    //       label :'Show Product Availability',
    //       input_type: 'checkbox__',
    //       type : 'text',
    //       name :'show_inventory',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : 0
    //     },
    //     {
    //       label :'Minimum Order Qty',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'minimum_order_qty',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : '1'
    //     },
    //     {
    //       label :'Maximum Order Qty',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'maximum_order_qty',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : '1000'
    //     },
    //   ]
    // },
    // {
    //   group_title : 'Shipping Info',
    //   mapped_by: 'shipping_info',
    //   group_fileds : [
    //     {
    //       label :'Enable Shipping',
    //       input_type: 'checkbox__',
    //       type : 'text',
    //       name :'enable_shipping',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : 0
    //     },
    //     {
    //       label :'Enable Free Shipping',
    //       input_type: 'checkbox__',
    //       type : 'text',
    //       name :'free_shipping',
    //       placeholder : '',
    //       required : false,
    //       hidden: true,
    //       value : 0
    //     },
    //     {
    //       label :'Additional Shipping Cost',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'additional_shipping_cost',
    //       placeholder : '',
    //       required : false,
    //       hidden: true,
    //       value : ''
    //     },
    //     {
    //       label :'Weight (In Lbs)',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'weight',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : ''
    //     },
    //     {
    //       label :'Gross Weight (In gms)',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'gross_weight',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : ''
    //     },
    //   ]
    // },
    // {
    //   group_title : 'Return Policy',
    //   mapped_by: 'shipping_info',
    //   group_fileds : [
    //     {
    //       label : "Return Policy",
    //       input_type: 'dropdown',
    //       type : 'text',
    //       name :'return_policy',
    //       placeholder : 'Tax Template',
    //       required : false,
    //       hidden: false,
    //       value : 'Return Policy',
    //       options:[{'name':'Return Policy'}],
    //       tooltip: '',
    //       // dropdown_api : 'Return Policy'
    //     }
    //   ]
    // },
    // {
    //   group_title : 'CATEGORY MAPPING',
    //   mapped_by: 'category_mapping',
    //   group_fileds : [
    //     {
    //       label :'Category Mapping',
    //       input_type: 'dropdown',
    //       type : 'multiple',
    //       name :'product_categories',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : "",
    //       multiple : true,
    //       function_name : 'get_category_list',
    //       field_name : 'name',
    //       field_label : 'category_name'
    //     },
    //   ]
    // },
    // {
    //   group_title : 'Search Engine Optimisation (SEO)',
    //   mapped_by: 'seo',
    //   group_fileds : [
    //     {
    //       label :'Meta Title',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'meta_title',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : ''
    //     },
    //     {
    //       label :'Friendly Url',
    //       input_type: 'input',
    //       type : 'text',
    //       name :'route',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : ''
    //     },
    //     {
    //       label :'Meta Keywords',
    //       input_type: 'textarea',
    //       type : 'text',
    //       name :'meta_keywords',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : ''
    //     },
    //     {
    //       label :'Meta Description',
    //       input_type: 'textarea',
    //       type : 'text',
    //       name :'meta_description',
    //       placeholder : '',
    //       required : false,
    //       hidden: false,
    //       value : ''
    //     },
    //   ]
    // }
  ]


  attributes : any = [ 
    'Dropdown List',
    'Radio Button List',
    'Checkbox List',
    'Color Boxes',
    'Text Box',
    'Table',
    'Multi Line Text'
  ]

 product_variants :any = [
  {
    product : this.product.name,
    product_attribute : '',
    control_type : '',
    options : ''
  }
 ]

  // "product":"ITEM-00001",
  // "display_order":0,
  // "attribute":"Size",
  // "quantity":0,
  // "attribute_unique_name":"",
  // "is_required":"Yes",
  // "control_type":"Dropdown List",
  // "options":"Small, Smallssss, Medium",


 

    async startScan(){
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode : 'environment'}
      });
    //  const stream = await navigator.mediaDevices.getUserMedia({
    //    video: {facingMode : 'environment'}
    //  })
    //  try {
    //   this.videoElement.srcObject = stream;
    //   } catch (error) {
    //   this.videoElement.src = URL.createObjectURL(stream);
    // }
      this.videoElement.srcObject = stream;
      this.videoElement.setAttribute('playsinline',true);
      this.videoElement.play();

    }


    async showQrToast(){
      const toast = await this.toastController.create({
      message: `open ${this.scanResult}?`,
      position: 'top',
      buttons: [
        {
          text: 'Open',
          handler: () => {
            window.open(this.scanResult, '_system','location=yes');
            // console.log('Favorite clicked');
          }
        }
      ]
    });
    await toast.present();
    }

    ngAfterViewInit(){
    this.video?  this.videoElement = this.video.nativeElement : null
    }

    reset(){
      this.scanResult = null;
    }

    stopScan(){
      this.scanActive = false;
    } 

    // getsearch() {
    //   this.menulist=[]
    //   for (var i = 0; i < this.categorylist.length; i++) {
    //     var k = i;
    //     if (this.categorylist[k].products != undefined) {
    //       // if (this.categorylist[k].Items != undefined) {
    //       for (var j = 0; j < this.categorylist[k].products.length; j++) {
    //         // for (var j = 0; j < this.categorylist[k].Items.length; j++) {
    //         var v = j
    //         this.menulist.push(this.categorylist[k].products[v]);
    //         // this.searchmenuitem.push(this.categorylist[k].Items[v]);
    //       }
    //     }
    //   }
    // }
  
    edititem(i, index) {
      // console.log(i)
      this.activeitem = index
      var data = {
        Product: i.name
      }
      this.DBservice.get_product(data)
        .subscribe(data => {
          // console.log(data.message)
          this.products = data.message
          this.upload_images = this.products.product_images
          // this.upload_images = this.products.images
          this.categoryimagedata = [];
          this.categoryfile = [];
          // console.log(this.upload_images)
        }, error => {
          console.log(JSON.stringify(error.json()));
        });
    }
  
    // get_all_category(){
    //    this.DBservice.get_all_categories().subscribe(data => {
    //       this.cat = data.message
    //       // console.log(this.cat);
    // }, error => {  console.log(JSON.stringify(error.json())); });
        
    // }
  
    go_to_category(){
      
    }
  
    validate(value,index,name){
       if(name == 'display_order')
         this.attibute_list[index].display_order = value.detail.value
    }
  
    open_product(content,title) {
       this.title = title;
       if(title == 'Add'){
         this.product= {}
        //  this.modalService.open(content);
       }
       else
       {
        //  console.log(this.products)
         this.product= this.products
         // this.category = this.products;
         // this.modalService.dismissAll()
        //  this.modalService.open(content);
  
       }
    }
  
    close_product(form){
      // console.log(form.valid)
      this.submitted = true;
      if(form.valid){
      this.product.is_active = true;
      this.product.domain = localStorage['active_domain'];
  
      // this.product.restaurant = localStorage.restaurantId;
      var product_categories:any = []
      if(this.product.item != undefined && this.product.price != undefined){
        if(this.product.product_categories)
          {
            for (let i = 0; i < this.product.product_categories.length; i++) {
            product_categories.push({
              category:this.product.product_categories[i]
            })
            } 
          }
        this.product.product_categories = product_categories
        this.product.product_attributes = this.attibute_list
        if(this.title == 'Edit'){
          var data={
            name: this.product.name,
            item: this.product.item,
            product_type: this.product.product_type,
            price: Number(this.product.price),
            old_price :Number(this.product.old_price),
            sku:this.product.sku,
            is_gift_card:this.product.is_gift_card,
            display_home_page:this.product.display_home_page,
            inventory_method:this.product.inventory_method,
            minimum_order_qty:this.product.minimum_order_qty,
            maximum_order_qty:this.product.maximum_order_qty,
            disable_add_to_cart_button:this.product.disable_add_to_cart_button,
            show_inventory:this.product.show_inventory,
            enable_shipping:this.product.enable_shipping,
            free_shipping:this.product.free_shipping,
            addtitional_shipping_cost:this.product.addtitional_shipping_cost,
            weight:this.product.weight,
            full_description:this.product.full_description,
            short_description:this.product.short_description,
            is_active:this.product.is_active,
            product_categories:this.product.product_categories,
            recipe:this.product.recipe,
            product_attributes:this.attibute_list,
            domain:localStorage['active_domain'],
  
          }
          this.insert_product(data,'Product Updated Successfully')
        }
        else
          this.insert_product(this.product,'Product Added Successfully')
      }
    }
    }
  
  
    open_attribute(modalpopup,title){
      this.title = title
      this.itemaddon = {};
      // this.close_att = this.modalService.open(modalpopup,{scrollable: true});
  }
  
  editoption(attr,index,modalpopup,title){
   this.i = index;
   this.title = title
   this.itemaddon = attr;
  //  this.close_att = this.modalService.open(modalpopup,{scrollable: true});
  }
  
  
  deleteoption(attr,index){
   this.attibute_list.splice(index,1)
  }
  
  close_attrbute(form,modalpopup){
   if(form.valid){
     if(this.title == 'Add')
       this.attibute_list.push(this.itemaddon)
     else
       this.attibute_list[this.i] = this.itemaddon
     this.close_att.close()
     // this.activeModal.dismiss()
   }
  }

  change_product_attr(value, index){
    let check_attribute:any = this.Product_attributes.find((obj:any)=>obj.name == value.detail.value);
    // console.log(check_attribute)
    if(check_attribute)
      this.attibute_list[index].attribute = check_attribute.attribute_name
    // console.log(value)
    // console.log(index)
  }

  edit_option(index,attr){
    let params: NavigationExtras = {  queryParams: {'id': attr.name},  }
     this.navCtrl.navigateForward(['add-option'], params);
  }
  


  variant_event(event){
    if(event){
      this.attibute_list = event
    }
    this.post_product();
  }

  navigate_to_full_screen(eve){

    let params: NavigationExtras = {
      queryParams: {'id': eve.name}
    }
    this.navCtrl.navigateForward(['addproduct'], params);
  }

  //Modal Image
  image_show(data:any) {
    var modal: any = document.getElementById("myModal");
    // let modal_parent:any = document.getElementsByClassName('job-detail-popup');
    // var arr:any = [].slice.call(modal_parent);
    // let val = Array.from(arr[0].classList)
    // console.log(val);
    // arr[0].classList.add("job_add");
    // console.log(arr[0].classList.add("job_add"))

    var img = document.getElementsByClassName("image_div2");
    var modalImg: any = document.getElementById("img01");
    modalImg.src = data.detail_thumbnail ? this.DBservice.product_img(data.detail_thumbnail) : this.DBservice.product_img(data.filedata)
    modal.style.display = "block";

  }
  // Get the modal

  close() {
    // let modal_parent:any = document.getElementsByClassName('job-detail-popup');
    // modal_parent.classList.remove("job_add");
    var span = document.getElementsByClassName("close")[0];
    var modal: any = document.getElementById("myModal");
    // When the user clicks on <span> (x), close the modal
    modal.style.display = "none";
  }

  remove_options(data,i){
    console.log(data);
    if(data && data.options && data.options[i] && data.options[i].attribute_id){
      let remove_option = data.options[i].attribute_id.split('\n');

      let datas = { option_id : remove_option[0] }

      this.DBservice.remove_variant_options(datas).subscribe(res=>{
        if(res && res.message && res.message.status == 'Success'){

          let attri_index = this.product.attribute_options.findIndex(r=> { return r.name == remove_option[0]})

          if(attri_index > 0){
            this.product.attribute_options.splice(attri_index, 1);
          }

          data.options.splice(i,1);
        }else{
          this.DBservice.alert('Something went wrong trg again later');
         }
       },error=>{ this.DBservice.alert('Something went wrong trg again later') })

    }else{
      data.options.splice(i,1);
    }
  }
  
}
